import {
  ACCESS_CONTROL_MANAGER_ROLES,
  AccessControlArea,
  AccessControlCode,
  FULL_ACCESS_USER_ROLES,
} from '@shared/constants';
import { UserRole } from '@shared/types';

export { AccessControlArea, AccessControlCode };

export interface AccessControlRecord {
  id: string;
  code: AccessControlCode | string;
  name: string;
  description: string;
  area: AccessControlArea;
  sort_order: number;
  created_at?: string;
  updated_at?: string;
}

export interface AccessPolicyRecord {
  id: string;
  company_id: number;
  name: string;
  description: string | null;
  created_by: string;
  created_at: string;
  updated_at: string;
}

export interface AccessPolicyControlRecord {
  id: string;
  policy_id: string;
  access_control_id: string;
  added_by: string;
  created_at: string;
}

export interface AccessPolicySummary extends AccessPolicyRecord {
  control_ids: string[];
  controls: AccessControlRecord[];
  assignment_count: number;
}

export interface RolePolicyAssignmentRecord {
  id: string;
  company_id: number;
  outlet_id: string;
  role: UserRole;
  policy_id: string;
  assigned_by: string;
  created_at: string;
  updated_at: string;
}

export interface SecuritySnapshot {
  controls: AccessControlRecord[];
  policies: AccessPolicySummary[];
  assignments: RolePolicyAssignmentRecord[];
}

export interface SaveAccessPolicyRequest {
  id?: string;
  companyId: number;
  createdBy: string;
  name: string;
  description?: string;
  controlIds: string[];
}

export interface SaveRolePolicyAssignmentRequest {
  companyId: number;
  outletId: string;
  role: UserRole;
  policyId: string | null;
  assignedBy: string;
}

export const UNRESTRICTED_SECURITY_ROLES = FULL_ACCESS_USER_ROLES;
export const SECURITY_MANAGER_ROLES = ACCESS_CONTROL_MANAGER_ROLES;

export const ASSIGNABLE_POLICY_ROLES: readonly UserRole[] = [
  UserRole.MANAGER,
  UserRole.WAITER,
  UserRole.CASHIER,
  UserRole.RECEPTIONIST,
  UserRole.ACCOUNTANT,
  UserRole.KDS,
] as const;
